import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectLoginTokenInfo } from "../../../../redux/features/loginRegisterSlice";
import BasicInfo from "../../../common/BasicInfo/BasicInfo";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import useAmanFlow from "../../../../hooks/useAmanFlow";
import useAmanFormData from "../../../../hooks/useAmanFormData";
import AmanJourneyLayout from "../../layouts/AmanJourneyLayout";
import BottomStickyBtnLayout from "../../layouts/BottomStickyBtnLayout";
import DocumentsReadyInfo from "./DocumentsReadyInfo";

const AMAN_BASIC_INFO = "AMAN_BASIC_INFO";

const StartPage = ({ onClose }) => {
    const { handleNextSubstep, currentSubstepIndex, currentStep, handlePrevSubstep } = useAmanFlow();
    const loginTokenInfo = useSelector(selectLoginTokenInfo);
    const isLoggedIn = !!loginTokenInfo;
    const translate = useLanguageTranslate();
    
    const { saveAmanDataInRedux } = useAmanFormData(AMAN_BASIC_INFO, () => {});

    useEffect(() => {
        // Guard with currentStep.name so this auto-advance does NOT fire while
        // the page is still mounted in AnimatePresence's exit transition
        // (when the next step's substepIndex briefly resets to 0).
        if (isLoggedIn && currentStep?.name === "start" && currentSubstepIndex !== 1) {
            handleNextSubstep();
        }
    }, [isLoggedIn, currentStep?.name, currentSubstepIndex, handleNextSubstep]);

    const handleBackToForm = () => {
        handlePrevSubstep();
    };

    const handleSaveBasicInfo = async (basicInfo) => {
        console.log("Aman Basic Info:", basicInfo);
        await saveAmanDataInRedux(basicInfo);
    };

    return (
        <div className="flex flex-col items-center gap-6 bg-white max767:p-0 w-full">
            {isLoggedIn ? (
                currentSubstepIndex === 1 ? (
                    <DocumentsReadyInfo
                        continueClickHandler={handleNextSubstep}
                        hide_back_btn={true}
                        show_close_btn={true}
                        onClose={onClose}
                        isFirstPage={true}
                    />
                ) : (
                    <div className="p-4">Loading...</div>
                )
            ) : (
                <>
                    {currentSubstepIndex === 0 ? (
                        <BasicInfo
                            title={translate("New Aman Insurance", "تأمين أمَانْ الجديد")}
                            subtitle={translate(
                                "Welcome! Let's start with some basic information.",
                                "مرحبًا! دعنا نبدأ ببعض المعلومات الأساسية."
                            )}
                            continueClickHandler={handleNextSubstep}
                            onClose={onClose}
                            onSaveBasicInfo={handleSaveBasicInfo}
                            JourneyLayoutComponent={AmanJourneyLayout}
                            BottomStickyBtnLayoutComponent={BottomStickyBtnLayout}
                            showCprField={true}
                        />
                    ) : currentSubstepIndex === 1 ? (
                        <DocumentsReadyInfo
                            continueClickHandler={handleNextSubstep}
                            customBackHandler={handleBackToForm}
                            onClose={onClose}
                            isFirstPage={false}
                        />
                    ) : null}
                </>
            )}
        </div>
    );
};

export default StartPage;
